import { WbsItemAdditionalPropertyGroupHeaderEntity } from '../../../../../../../../domain/entity/WbsItemAdditionalPropertyGroupHeaderEntity'
import { i18nLabelVoService } from '../../../../../../../../domain/value-object/I18nLabelVO'
import { TableHeaderDef } from '../../../../../../../containers/SingleSheetV2/table/model'

export const toTableHeaderDef = (
  groupHeader: WbsItemAdditionalPropertyGroupHeaderEntity
): TableHeaderDef => {
  return {
    externalId: groupHeader.entityExtensionExternalId || groupHeader.uuid,
    label: i18nLabelVoService.getLabel(groupHeader.headerNameI18n),
  }
}
